import React from "react";

import { useSelector } from "react-redux";

import { Box } from "@mui/material";
import { Input, Label } from 'reactstrap'

export default function AssetsContractItem({ type, nameLink, url, pathname, push }) {
    const contracts = useSelector((state) => state.contract.items);
    const trueContract = contracts.filter((item) => item.type === type);

    if (trueContract.length === 0) {
        return null
    }

    return (
        <li>
            <Box
                sx={{
                    padding: "0",
                    fontFamily: "Montserrat",
                    fontWeight: 700,
                    fontSize: "1.25rem",
                }}
                component="ul"
            >
                {nameLink}
                <li>
                    <ul style={{ padding: 0 }}>
                        {trueContract.length > 0 ? (
                            trueContract.map((item) => {
                                return (
                                    <li key={item._id}>
                                        <Input
                                            type='radio'
                                            id={item._id}
                                            name='contract-radio'
                                            className="me-2"
                                            defaultChecked={pathname.split('/').at(-1) === item._id}
                                            onClick={() => push(`${url}/${item._id}`)}
                                        />
                                        <Label className='form-check-label' for={item._id}>
                                            {item?.customName ?? item.name}
                                        </Label>
                                    </li>
                                );
                            })
                        ) : (
                            <p>(No data for display)</p>
                        )}
                    </ul>
                </li>
            </Box>
        </li>
    );
}
